export default "__VITE_ASSET__L0QEP_No__"